/**
 * PostnlPageTabs — PostNL sayfaları (Dagplanning / Ritmonitor / Hesaplar)
 * arasında tek-tık geçiş için ortak tab şeridi. Her sayfada başlık altında
 * render edilir.
 *
 * `useLocation` ile aktif tab vurgulanır. Tab tıklaması React Router
 * navigate ile çalışır (full page reload yok).
 */
import { NavLink } from 'react-router-dom';
import { Package, Truck, Key } from 'lucide-react';

const TABS = [
  { to: '/dashboard/postnl/dagplanning', label: 'Dagplanning', icon: Package },
  { to: '/dashboard/postnl/ritmonitor', label: 'Ritmonitor', icon: Truck },
  { to: '/dashboard/postnl/accounts', label: 'Hesaplar', icon: Key },
];

export default function PostnlPageTabs() {
  return (
    <div
      className="flex gap-1 border-b border-slate-200 dark:border-slate-700 overflow-x-auto -mb-px"
      data-testid="postnl-page-tabs"
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end
            className={({ isActive }) => `px-4 py-2 text-sm font-medium border-b-2 transition flex items-center gap-2 whitespace-nowrap ${
              isActive
                ? 'border-orange-500 text-orange-600 dark:text-orange-400'
                : 'border-transparent text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'
            }`}
            data-testid={`postnl-page-tab-${t.label.toLowerCase()}`}
          >
            <Icon className="h-4 w-4" />
            {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
